import styled from 'styled-components';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

export const ImportRow = styled.div`
  padding: 30px 0;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  &:last-child {
    padding-bottom: 0;
  }
`;

export const RowContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-wrap: nowrap;
`;

export const IntegrationHelp = styled.div`
  margin-top: 30px;
  h5 {
    padding: 0 0 30px;
    font-size: 1rem;
    font-weight: 600;
    border-top: 0;
    margin: 0;
  }
`;

export const RowTitle = styled.div`
  padding-top: 2px;
  display: flex;
  align-items: center;
`;

export const TitleTxt = styled.div<{ $noIcon?: boolean }>`
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a8};
  margin-left: ${({ $noIcon }) => ($noIcon ? 55 : 15)}px;

  a {
    color: ${({ theme }) => theme.baseBlue.a8};
    text-decoration: underline;
  }
`;

export const ImportRightCol = styled.div`
  display: flex;
  margin-left: 30px;
  align-items: start;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 15px;
`;

export const ImportBtnBox = styled.div<{ $isHidden?: boolean }>`
  display: flex;
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'visible')};
  min-height: 60px;
`;

export const BtnCell = styled.div`
  margin-left: 15px;
`;

export const SettingsBlock = styled.div<{ $timeout: number }>`
  max-height: 0;
  overflow: hidden;
  transition: max-height ${({ $timeout }) => $timeout}ms;

  &.entering,
  &.entered {
    max-height: 5000px;
  }
`;

export const FormContentBox = styled.div`
  padding-top: 20px;
`;

export const TooltipBox = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: 0.8rem;
  padding: 0 5px;
  border-left: 1px solid ${({ theme }) => theme.black.a1};
`;

export const ButtonsBox = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 15px 0 30px;
  flex-direction: column;
  position: relative;
`;

export const ButtonsRow = styled.div`
  display: flex;
`;

export const CancelBtn = styled(SecondaryButton)`
  margin-left: 15px;
`;

export const ErrorBox = styled.div`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 5px;
  text-transform: uppercase;
`;
